/* eslint-disable */
import type { Dealer } from './dealer';

export enum AppToTrack {
  DEALER_SEARCH_APP = 'dealer search app',
}

export const appReady = (componentName = '') => {
  return {
    event: {
      eventInfo: {
        eventAction: 'feature_app_ready',
        eventName: componentName
          ? `dealer search - ${componentName.split('-').join(' ')} - feature app ready`
          : 'feature app ready',
      },
      attributes: {
        componentName,
        label: '',
        currentURL: window.location.href,
        targetURL: '',
        clickID: '',
        elementName: '',
        value: '',
        pos: '',
      },
    },
  };
};

export const impression = (featureAppName = '', value = '', componentName?: string) => {
  return {
    event: {
      eventInfo: {
        eventAction: 'impression',
        eventName: featureAppName
          ? `dealer search - ${featureAppName.split('-').join(' ')} - impression`
          : 'impression',
      },
      attributes: {
        componentName,
        label: '',
        currentURL: window.location.href,
        targetURL: '',
        clickID: '',
        elementName: '',
        value,
        pos: '',
      },
    },
  };
};

export const locateUser = () => {
  return {
    event: {
      eventInfo: {
        eventAction: 'internal_link',
        eventName: 'dealer search - click on locate me',
      },
      attributes: {
        componentName: 'dealer-search',
        label: '',
        targetURL: '',
        clickID: '',
        elementName: 'icon',
        value: '',
        pos: '',
      },
    },
  };
};

export const userLocationNotRetrieved = (text: string) => {
  return {
    event: {
      eventInfo: {
        eventAction: 'callback',
        eventName: 'dealer search - localization not successful',
      },
      attributes: {
        componentName: 'dealer-search',
        label: '',
        targetURL: '',
        clickID: '',
        elementName: '',
        value: text,
        pos: '',
      },
    },
  };
};

export enum searchTypeEnum {
  BY_TERM = 'searched by term',
  BY_ZIPCODE = 'searched by address: zip code',
  GEOLOCATION = 'searched by address: geolocation',
}

export const searchResult = (
  term: string,
  resultsNum: number,
  searchType: searchTypeEnum,
  filters: string[],
  dealers: Dealer[],
  preferredDealer: Dealer | null,
  initialStart: boolean,
) => {
  return {
    event: {
      eventInfo: {
        eventAction: 'view_change',
        eventName: 'dealer search - display results',
      },
      attributes: {
        componentName: 'dealer-search-map-app',
        label: '',
        currentURL: window.location.href,
        targetURL: '',
        clickID: '',
        elementName: '',
        value: '',
        pos: '',
        initialStart,
      },
    },
    componentUpdate: {
      page: {
        pageInfo: {
          pageID: 'dealer search - display results',
        },
      },
      search: {
        name: 'dealer search',
        term,
        results: resultsNum,
        type: searchType,
        filter: filters.map((filter) => ({
          name: filter,
        })),
      },
      dealer: {
        dealerResults: dealers.map((dealer) => ({
          dealerInfo: {
            dealerID: dealer.dealerId || '',
            dealerName: dealer.name || '',
          },
          attributes: {
            partnerServicesDetails: dealer.services || [],
            matPrimaryCode: dealer.matPrimaryCode || '',
            kvpsPartnerKey: dealer.kvpsPartnerKey || '',
          },
        })),
        preferredDealer: {
          dealerInfo: {
            dealerID: preferredDealer ? preferredDealer.dealerId || '' : '',
            dealerName: preferredDealer ? preferredDealer.name || '' : '',
          },
          attributes: {
            partnerServicesDetails: preferredDealer ? preferredDealer.services || [] : [],
            matPrimaryCode: preferredDealer ? preferredDealer.matPrimaryCode || '' : '',
            kvpsPartnerKey: preferredDealer ? preferredDealer.kvpsPartnerKey || '' : '',
          },
        },
      },
    },
  };
};

export enum MapAppSearchResultEnum {
  SUBMIT = 'submit',
  LOCATION_SUBMIT = 'submit location',
  RESULT_SUBMIT = 'result click (on list)',
  QUICK_RESULT_SUBMIT = 'quick search result click',
  SEARCH_THIS_AREA = 'search in this area',
  CHANGE_RADIUS = 'change search radius',
  MAP_PIN_CLICK = 'result click (on map)',
  ADD_FILTER = 'add filter',
  REMOVE_FILTER = 'remove filter',
  DO_NOT_STORE_FILTER = 'do not store filter changes',
}

export enum MapAppSearchResultElementNameEnum {
  OTHER = 'other',
  TEXT_LINK = 'text link',
  BUTTON = 'button',
  ICON = 'icon',
  DROP_DOWN = 'drop down',
}

export const mapAppSearchResult = (
  mapAppSearchResultEnum: MapAppSearchResultEnum,
  component: string,
  label: string,
  searchValue: string,
  element: MapAppSearchResultElementNameEnum,
  pos: string | number | undefined,
  targetURL: string,
) => {
  return {
    event: {
      eventInfo: {
        eventAction: 'internal_link',
        eventName: `dealer search - ${mapAppSearchResultEnum}`,
      },
      attributes: {
        componentName: component,
        label,
        currentURL: window.location.href,
        targetURL,
        clickID: '',
        elementName: element,
        value: searchValue,
        pos,
      },
    },
  };
};

export const dealerDetails = (
  dealerID: string,
  dealerName: string,
  partnerServiceDetails: [],
  matPrimaryCode: string,
  kvpsPartnerKey: string,
) => {
  return {
    event: {
      eventInfo: {
        eventAction: 'view_change',
        eventName: 'dealer search - display dealer details',
      },
      attributes: {
        componentName: 'dealer-search-map-app',
        label: '',
        targetURL: '',
        clickID: '',
        elementName: '',
        value: '',
        pos: '',
        initialStart: false,
        relatedDealer: {
          dealerInfo: {
            dealerID,
            dealerName,
          },
          attributes: {
            partnerServiceDetails,
            matPrimaryCode,
            kvpsPartnerKey,
          },
        },
      },
    },
    componentUpdate: {
      page: {
        pageInfo: {
          pageID: 'dealer search - display dealer details',
        },
      },
    },
  };
};

export const emptyState = (preferredDealer: Dealer | null, initialStart: boolean) => {
  return {
    event: {
      eventInfo: {
        eventAction: 'view_change',
        eventName: 'dealer search - empty state',
      },
      attributes: {
        componentName: 'dealer-search-map-app',
        label: '',
        targetURL: '',
        clickID: '',
        elementName: '',
        value: '',
        pos: '',
        initialStart,
      },
    },
    componentUpdate: {
      page: {
        pageInfo: {
          pageID: 'dealer search - empty state',
        },
      },
      dealer: {
        preferredDealer: {
          dealerInfo: {
            dealerID: preferredDealer ? preferredDealer.dealerId || '' : '',
            dealerName: preferredDealer ? preferredDealer.name || '' : '',
          },
          attributes: {
            partnerServicesDetails: preferredDealer ? preferredDealer.services || [] : [],
            matPrimaryCode: preferredDealer ? preferredDealer.matPrimaryCode || '' : '',
            kvpsPartnerKey: preferredDealer ? preferredDealer.kvpsPartnerKey || '' : '',
          },
        },
      },
    },
  };
};
